export default __webpack_public_path__ + "static/media/Background_00193.a521e7c3.png";